export default "__VITE_ASSET__753de874__"